module.exports = __webpack_public_path__ + "img/profile-bg4.f4ed7489.jpg";